import { Image } from 'primereact/image';
import { Component, useState } from 'react';
import cardModel from '../../static/card-model';
import { Link } from 'react-router-dom';
import { getUserCards } from '../../service/card.service';
import { checkCardIsSelected, goTo, returnCardInfo, returnCatalogId, setSelectedCard,} from "../../utilities/common.utilities";
import { getUserPoints } from '../../service/points.service';
import './home.css';

type HomeState = {
  selectedCard: string;
  groupCode: string;
  storeCode: string;
  cardPoints: number;
  cardCustomerName: string;
  noCardLinked: boolean;
  catalogId: string;

};

class Home extends Component<{}, HomeState> {
  state: HomeState = {
    selectedCard: '',
    groupCode: '',
    storeCode: '',
    cardPoints: 0,
    cardCustomerName: '',
    noCardLinked: false,
    catalogId: '',

  };  

  componentDidMount() {
    localStorage.removeItem("firstCardAdded")
    localStorage.removeItem("cardChanged")
    if (checkCardIsSelected()) {
      returnCardInfo().then(async (card) => {
        const catalogId = await returnCatalogId();
        //getUserPoints(card.groupCode,card.storeCode,card.card, catalogId).then(points => {
        this.setState({
          selectedCard: card.card,
          groupCode: card.groupCode,
          storeCode: card.storeCode,
          //cardPoints: points.totalPoints,
          cardCustomerName: card.customerName,
          catalogId: catalogId,
        });
        //});
      });
    } else {
      getUserCards().then(async (cardData: cardModel) => {
        if (cardData.cards.length > 0) {
          const groupCode = cardData.cards[0].groupId.toString();
          const storeCode = cardData.cards[0].mainStoreCode;
          const card = cardData.cards[0].cardNumber;
          const cardCustomerName = cardData.cards[0].customerName;
          setSelectedCard(card);

          const catalogId = await returnCatalogId();
          //getUserPoints(groupCode,storeCode,card, catalogId).then(points => {
          this.setState({
            selectedCard: card,
            groupCode: groupCode,
            storeCode: storeCode,
            //cardPoints: points.totalPoints,
            cardCustomerName: cardCustomerName,
            catalogId: catalogId,
          });
          //});
        } else {
          // no card linked
          this.setState({
            noCardLinked: true,
          });
        }
      });
    }
  }

  render() {
    return (
      <>       
            <div className="mt-2">
              <div className="grid m-0 mb-3">
                <div className="col-4 mt-3">
                  <div className="flex flex-column">
                    <div className="flex align-items-center justify-content-center">
                      <Link
                        to={{ pathname: "/fidelity-card" }}
                        state={{ cardData: this.state }}
                      >
                        <Image
                          id="fedelityCardIcon"
                          className="rounded-circle mr-2 justify-content-center"
                          src="new_icons/card.svg"
                          width="80px"
                          // imageStyle={{ rotate: "30deg" }}
                        ></Image>
                      </Link>
                    </div>
                    <div className="flex align-items-center justify-content-center font-bold text-center">
                      CARD
                    </div>
                  </div>
                </div>

                {this.state?.catalogId ? (
                  <div className="col-4 mt-3">
                    <div className="flex flex-column">
                      <div className="flex align-items-center justify-content-center">
                        <Link
                          to={{ pathname: "/rewards-points" }}
                          state={{ cardData: this.state }}
                        >
                          <Image
                            id="puntiPremiIcon"
                            className="rounded-circle mr-2 justify-content-center"
                            src="new_icons/catalogo-premi.svg"
                            width="88px"
                          ></Image>
                        </Link>
                      </div>
                      <div className="flex align-items-center justify-content-center font-bold text-center">
                        CATALOGO PREMI
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="col-4 mt-3">
                    <div className="flex flex-column">
                      <div className="flex align-items-center justify-content-center">
                        {/* <Link to={{pathname:"/rewards-points"}} state={{cardData: this.state}}> */}
                          <Image
                            id="puntiPremiIcon"
                            className="catalogo-assente rounded-circle mr-2 justify-content-center"
                            src="new_icons/catalogo-premi.svg"
                            width="88px"
                          ></Image>
                        {/* </Link> */}
                      </div>
                      <div className="flex flex-column align-items-center justify-content-center text-center">
                        <div className="font-bold">CATALOGO PREMI</div>
                      </div>
                    </div>
                  </div>
                )}

                <div className="col-4 mt-3">
                  <div className="flex flex-column">
                    <div className="flex align-items-center justify-content-center">
                      <Link
                        to={{ pathname: "/yourRewards" }}
                        state={{ cardData: this.state }}
                      >
                        <Image
                          id="yourRewardsIcon"
                          className="rounded-circle mr-2 justify-content-center"
                          src="new_icons/premi.svg"
                          width="80px"
                        ></Image>
                      </Link>
                    </div>
                    <div className="flex align-items-center justify-content-center font-bold text-center">
                      I MIEI PREMI
                    </div>
                  </div>
                </div>

                <div className="col-4 mt-3">
                  <div className="flex flex-column">
                    <div className="flex align-items-center justify-content-center">
                      <Link
                        to={{ pathname: "/coupons" }}
                        state={{ cardData: this.state }}
                      >
                        <Image
                          id="couponsIcon"
                          className="rounded-circle mr-2 justify-content-center"
                          src="new_icons/coupon.svg"
                          width="80px"
                        ></Image>
                      </Link>
                    </div>
                    <div className="flex align-items-center justify-content-center font-bold text-center">
                      COUPON
                    </div>
                  </div>
                </div>

                <div className="col-4 mt-3">
                  <div className="flex flex-column">
                    <div className="flex align-items-center justify-content-center">
                      <Link
                        to={{ pathname: "/events" }}
                        state={{ cardData: this.state }}
                      >
                        <Image
                          id="eventiIcon"
                          className="rounded-circle mr-2 justify-content-center"
                          src="new_icons/eventi.svg"
                          width="80px"
                        ></Image>
                      </Link>
                    </div>
                    <div className="flex align-items-center justify-content-center font-bold text-center">
                      EVENTI
                    </div>
                  </div>
                </div>

                <div className="col-4 mt-3">
                  <div className="flex flex-column">
                    <div className="flex align-items-center justify-content-center">
                      <Link
                        to={{ pathname: "/promo" }}
                        state={{ cardData: this.state }}
                      >
                        <Image
                          id="promoIcon"
                          className="rounded-circle mr-2 justify-content-center"
                          src="new_icons/promozioni.svg"
                          width="88px"
                        ></Image>
                      </Link>
                    </div>
                    <div className="flex align-items-center justify-content-center font-bold text-center">
                      PROMOZIONI
                    </div>
                  </div>
                </div>

                <div className="col-4 mt-3">
                  <div className="flex flex-column">
                    <div className="flex align-items-center justify-content-center">
                      <Link
                        to={{ pathname: "/service" }}
                        state={{ cardData: this.state }}
                      >
                        <Image
                          id="serviziIcon"
                          className="rounded-circle mr-2 justify-content-center"
                          src="new_icons/servizi.svg"
                          width="80px"
                        ></Image>
                      </Link>
                    </div>
                    <div className="flex align-items-center justify-content-center font-bold text-center">
                      SERVIZI
                    </div>
                  </div>
                </div>

                <div className="col-4 mt-3">
                  <div className="flex flex-column">
                    <div className="flex align-items-center justify-content-center">
                      <Link
                        to={{ pathname: "/flyers" }}
                        state={{ cardData: this.state }}
                      >
                        <Image
                          id="bookingIcon"
                          className="rounded-circle mr-2 justify-content-center"
                          src="new_icons/volantini.svg"
                          width="80px"
                        ></Image>
                      </Link>
                    </div>
                    <div className="flex align-items-center justify-content-center font-bold text-center">
                      VOLANTINI
                    </div>
                  </div>
                </div>

                <div className="col-4 mt-3">
                  <div className="flex flex-column">
                    <div className="flex align-items-center justify-content-center">
                      <Link
                        to={{ pathname: "/pharmacy" }}
                        state={{ cardData: this.state }}
                      >
                        <Image
                          id="farmaciaIcon"
                          className="rounded-circle mr-2 justify-content-center"
                          src="new_icons/info.svg"
                          width="80px"
                        ></Image>
                      </Link>
                    </div>
                    <div className="flex align-items-center justify-content-center font-bold text-center">
                      INFO e CONTATTI
                    </div>
                  </div>
                </div>
              </div>
            </div>
      </>
    );
  }
}
export default Home;
